import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const card: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  borderRadius: 2.75,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[3],
  p: { xs: 2.5, sm: theme.spacing(2.75, 3) },
  display: "flex",
  flexDirection: "column",
  gap: { xs: 2, sm: 2.25 },
});

export const header: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  flexWrap: "wrap",
};

export const title: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: { xs: "0.9375rem", sm: "1rem" },
};

export const viewAllLink: SxProps<Theme> = {
  fontSize: "0.8125rem",
  fontWeight: 600,
};

export const tableWrap: SxProps<Theme> = {
  width: "100%",
  minWidth: 0,
};

export const loadingState: SxProps<Theme> = (theme) => ({
  py: theme.spacing(6),
  display: "flex",
  justifyContent: "center",
});

export const errorState: SxProps<Theme> = (theme) => ({
  py: theme.spacing(4),
  textAlign: "center",
  color: "text.secondary",
});

export const emptyBox: SxProps<Theme> = {
  py: { xs: 5, sm: 8 },
  px: 3,
  minHeight: { xs: 320, sm: 440 },
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  textAlign: "center",
};

export const emptyIconWrap = (theme: Theme): SxProps<Theme> => ({
  width: { xs: 96, sm: 110 },
  height: { xs: 96, sm: 110 },
  borderRadius: { xs: 3.25, sm: 3.5 },
  bgcolor: alpha(theme.palette.primary.main, 0.1),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 1,
});

export const emptyTitle: SxProps<Theme> = {
  fontSize: { xs: "1.03125rem", sm: "1.1875rem" },
  fontWeight: 700,
};

export const emptyDescription: SxProps<Theme> = {
  fontSize: { xs: "0.78125rem", sm: "0.84375rem" },
  color: "text.secondary",
  maxWidth: 380,
  lineHeight: 1.8,
};

export const emptyActionWrap: SxProps<Theme> = (theme) => ({
  mt: theme.spacing(1.75),
});
